import React from "react";
import "../../assets/styles/footer.css";
import Logo from "../../assets/images/new.png";

const Footer = () => {
  return (
    <footer
      className="footer text-light py-5"
      style={{ backgroundColor: "#18181C" }}
    >
      <div className="container-fluid ">
        {" "}
        {/* Changed from 'container' to 'container-fluid' */}
        <div className="row justify-content-center align-items-start g-0">
          <div
            className="col-12 col-md-2 text-left text-md-start pe-md-1 px-5 
                mb-6 mb-md-0 ms-4 ms-md-0"
          >
            <img
              src={Logo}
              alt="Logo"
              style={{ height: "60px", objectFit: "contain" }}
              className="footerlogo"
            />
          </div>

          {/* Divider - Only visible on XL and above */}
          <div
            className="d-none d-xl-block border-end border-light mx-2"
            style={{ height: "200px", width: "2px" }}
          ></div>

          {/* Column 1 - Sri Lanka */}
          <div className="col-12 col-md-auto text-left text-md-start pe-md-1 px-5">
            <h5 style={{ color: "#9DFF00" }}>commceed SRILANKA PVT LTD.</h5>
            <ul className="list-unstyled">
              <li className="text-light">No: 590, Galle Road, Colombo 03.</li>
              {/* <li className="text-light">Galle Road,</li>
              <li className="text-light">Colombo 03.</li> */}
            </ul>
          </div>
          <div
            className="d-none d-xl-block border-end border-light mx-2"
            style={{ height: "200px", width: "2px" }}
          ></div>

          {/* Column 2 - Singapore */}
          <div className="col-12 col-md-auto  text-left text-md-start pe-md-1 px-5">
            <h5 style={{ color: "#9DFF00" }}>commceed SINGAPORE PTE LTD.</h5>
            <ul className="list-unstyled">
              <li className="text-light">
                IC Anson Road, #22 -02, International <br/>Place, Singapore, 079903.
              </li>
              <li style={{ fontSize: "17px" }}>
                <span style={{ minWidth: "95px", display: "inline-block" }}>
                  Office
                </span>
                : +65 6931 1711
              </li>
              {/* <li className="text-light">#22 -02,</li>
              <li className="text-light">International Place</li>
              <li className="text-light">Singapore 079903</li> */}
            </ul>
          </div>
          {/* <div
            className="d-none d-xl-block border-end border-light mx-2"
            style={{ height: "200px", width: "2px" }}
          ></div> */}
          {/* Column 3 - Australia */}
          {/* <div className="col-12  col-md-auto text-left text-md-start pe-md-1 px-5">
            <h5 style={{ color: "#9DFF00" }}>commceed AUSTRALIA PTY LTD</h5>
            <ul className="list-unstyled">
              <li className="text-light">
                Suite 648, 44 Lakeview Drive
                <br /> Scoresby, VIC 3179 Australia.
              </li>
              <li style={{ fontSize: "17px" }}>
                <span style={{ minWidth: "95px", display: "inline-block" }}>
                  Office
                </span>
                : +61 3 8564 8530
              </li>
              <li style={{ fontSize: "17px" }}>
                <span style={{ minWidth: "95px", display: "inline-block" }}>
                  Sales
                </span>
                : +61 478 97 6061
              </li>
              <li style={{ fontSize: "17px" }}>
                <span style={{ minWidth: "95px", display: "inline-block" }}>
                  WhatsApp
                </span>
                : +61 478 97 6061
              </li>
            
            </ul>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
